export enum ClinicianRole {
  ADMIN = 'S',
  BILLER = 'B',
  MINIMAL = 'M',
  SCHEDULER = 'A',
  TECHNICIAN = 'T',
  UNRESTRICTED = 'U',
}